/* MC Argollas Luxe — global.js
   JS vanilla, progresivo. Todo funciona sin frameworks. */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  const formatMoney = (cents) =>
    new Intl.NumberFormat('es-MX', { style: 'currency', currency: window.MCTheme?.currency || 'MXN' }).format(cents / 100);

  /* ---------- Header sticky con reducción de altura ---------- */
  const headerWrap = $('.site-header-wrapper');
  if (headerWrap) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY; if (y > 80) headerWrap.classList.add('is-scrolled'); else if (y < 20) headerWrap.classList.remove('is-scrolled');
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Mega menú (hover en desktop + click/teclado accesible) ---------- */
  $$('.site-nav__item--has-mega').forEach((item) => {
    const trigger = item.querySelector('.site-nav__link');
    let closeTimer;
    const open = () => { clearTimeout(closeTimer); closeAllMega(item); item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
    const close = () => { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => { closeTimer = setTimeout(close, 150); });
    trigger.addEventListener('click', (e) => {
      if (!item.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  });
  function closeAllMega(except) {
    $$('.site-nav__item--has-mega.is-open').forEach((el) => {
      if (el !== except) {
        el.classList.remove('is-open');
        el.querySelector('.site-nav__link')?.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Drawers genéricos (menú móvil, carrito, overlay) ---------- */
  const overlay = $('#DrawerOverlay');
  let activeDrawer = null;
  function openDrawer(drawer) {
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('button, a, input')?.focus();
  }
  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    activeDrawer = null;
  }
  window.MCDrawers = { openDrawer, closeDrawer };
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); const d = $(opener.dataset.drawerOpen); d && openDrawer(d); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });

  /* ---------- Buscador con predicción ---------- */
  const searchPanel = $('#SearchPanel');
  const searchToggle = $('[data-search-toggle]');
  function closeSearch() { searchPanel?.classList.remove('is-open'); searchToggle?.setAttribute('aria-expanded', 'false'); }
  searchToggle?.addEventListener('click', () => {
    const isOpen = searchPanel.classList.toggle('is-open');
    searchToggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) $('#SearchInput')?.focus();
  });

  const searchInput = $('#SearchInput');
  const predictiveBox = $('#PredictiveResults');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { predictiveBox.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${window.MCTheme.routes.predictive_search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`);
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        predictiveBox.innerHTML = doc.querySelector('#PredictiveResultsInner')?.innerHTML || '';
      } catch (e) { /* silencioso */ }
    }, 250);
  });

  /* ---------- Carrito: agregar, actualizar, re-render vía Section Rendering ---------- */
  async function refreshCartDrawer(openAfter) {
    const res = await fetch(`${window.MCTheme.routes.root}?sections=cart-drawer`);
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('#CartDrawer');
    const current = $('#CartDrawer');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      const count = fresh.dataset.count;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('visually-hidden', count === '0');
      });
      current.dataset.count = count;
    }
    if (openAfter) openDrawer(current);
  }
  window.MCCart = { refreshCartDrawer };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-button]');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.addingText || '…';
    try {
      const res = await fetch(window.MCTheme.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = btn.dataset.addedText || original;
      await refreshCartDrawer(true);
    } catch (err) {
      window.location.href = window.MCTheme.routes.cart;
    } finally {
      setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1600);
    }
  });

  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !removeBtn) return;
    e.preventDefault();
    const el = qtyBtn || removeBtn;
    const line = el.dataset.line;
    let quantity = 0;
    if (qtyBtn) {
      const input = $(`[data-qty-input][data-line="${line}"]`);
      quantity = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qtyChange, 10));
    }
    await fetch(window.MCTheme.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity })
    });
    await refreshCartDrawer(false);
    if (document.body.classList.contains('template-cart')) window.location.reload();
  });

  /* ---------- Página de producto: variantes, precio, galería ---------- */
  $$('[data-product-wrapper]').forEach((wrapper) => {
    const dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = wrapper.querySelector('form[data-product-form]');
    const idInput = form?.querySelector('input[name="id"]');
    const priceEl = wrapper.querySelector('[data-price]');
    const btn = form?.querySelector('[data-add-button]');

    function selectedOptions() {
      return $$('[data-option-index]', wrapper)
        .reduce((acc, group) => {
          const checked = group.querySelector('input:checked');
          acc[Number(group.dataset.optionIndex)] = checked ? checked.value : null;
          return acc;
        }, []);
    }
    function findVariant(opts) {
      return product.variants.find((v) => v.options.every((val, i) => val === opts[i]));
    }
    function updateAvailability(opts) {
      $$('[data-option-index]', wrapper).forEach((group) => {
        const idx = Number(group.dataset.optionIndex);
        $$('input', group).forEach((input) => {
          const test = opts.slice();
          test[idx] = input.value;
          const match = product.variants.find((v) => v.options.every((val, i) => test[i] === null || val === test[i]));
          const label = input.nextElementSibling;
          label?.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function onChange() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      updateAvailability(opts);
      $$('[data-selected-value]', wrapper).forEach((el) => {
        const idx = Number(el.dataset.selectedValue);
        el.textContent = opts[idx] || '';
      });
      if (!variant) {
        btn && (btn.disabled = true, btn.textContent = btn.dataset.unavailableText);
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        let html = '';
        if (variant.compare_at_price > variant.price) {
          html = `<span class="price__sale">${formatMoney(variant.price)}</span><s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
        } else {
          html = `<span class="price__regular">${formatMoney(variant.price)}</span>`;
        }
        priceEl.innerHTML = html;
      }
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.dataset.addText : btn.dataset.soldoutText;
      }
      if (variant.featured_media) {
        const thumb = wrapper.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        thumb?.click();
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    wrapper.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) onChange(); });

    /* Galería: miniaturas + zoom */
    const mainImg = wrapper.querySelector('[data-gallery-main] img');
    const mainWrap = wrapper.querySelector('[data-gallery-main]');
    $$('[data-media-id]', wrapper).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-media-id]', wrapper).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg) { mainImg.src = thumb.dataset.src; mainImg.srcset = thumb.dataset.srcset || ''; mainImg.alt = thumb.querySelector('img')?.alt || ''; }
        mainWrap?.classList.remove('is-zoomed');
      });
    });
    mainWrap?.addEventListener('click', (e) => {
      mainWrap.classList.toggle('is-zoomed');
      if (mainWrap.classList.contains('is-zoomed')) {
        const rect = mainWrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = `${x}% ${y}%`;
      }
    });
  });

  /* ---------- Carruseles con flechas ---------- */
  $$('[data-slider]').forEach((section) => {
    const track = section.querySelector('.product-slider, .testimonial-slider');
    if (!track) return;
    section.querySelector('[data-slide-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
    });
    section.querySelector('[data-slide-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  /* ---------- Filtros de colección: envío en vivo vía Section Rendering ---------- */
  const facetsForm = $('#FacetsForm');
  if (facetsForm) {
    const sectionId = facetsForm.dataset.sectionId;
    let facetTimer;
    async function applyFilters() {
      const params = new URLSearchParams(new FormData(facetsForm));
      const sortSelect = $('[data-sort-select]');
      if (sortSelect?.value) params.set('sort_by', sortSelect.value);
      const query = params.toString();
      const url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
      const grid = $('#CollectionProducts');
      grid?.classList.add('is-loading');
      try {
        const res = await fetch(`${window.location.pathname}?${query ? query + '&' : ''}section_id=${sectionId}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['#CollectionProducts', '#ActiveFacets', '#CollectionCount', '#FacetGroups'].forEach((id) => {
          const fresh = doc.querySelector(id);
          const current = $(id);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        window.history.pushState({}, '', url);
      } finally {
        grid?.classList.remove('is-loading');
      }
    }
    facetsForm.addEventListener('change', () => { clearTimeout(facetTimer); facetTimer = setTimeout(applyFilters, 250); });
    facetsForm.addEventListener('submit', (e) => { e.preventDefault(); applyFilters(); });
    $('[data-sort-select]')?.addEventListener('change', applyFilters);
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-facet-remove]');
      if (!chip) return;
      e.preventDefault();
      window.location.href = chip.getAttribute('href');
    });
    $('[data-facets-open]')?.addEventListener('click', () => $('#Facets')?.classList.add('is-open'));
    $$('[data-facets-close]').forEach((b) => b.addEventListener('click', () => $('#Facets')?.classList.remove('is-open')));
  }

  /* ---------- Animación de entrada por scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }
    /* Cotizacion por WhatsApp: mensaje dinamico con opciones */
      $$('[data-quote-whatsapp]').forEach(function (btn) {
          var form = btn.closest('form') || document.querySelector('[data-product-form]') || document;
              function build() {
                    var num = (btn.getAttribute('data-wa-number') || '').replace(/[^0-9]/g, '');
                          var name = btn.getAttribute('data-product-name') || '';
                                var url = btn.getAttribute('data-product-url') || location.href;
                                      var opts = $$('input[name^="options["]:checked', form).map(function (i) {
                                              var m = i.name.match(/options\[(.+)\]/);
                                                      return (m ? m[1] : '') + ': ' + i.value;
                                                            });
                                                                  var msg = 'Hola, quiero cotizar: ' + name;
                                                                        if (opts.length) { msg += '. Opciones: ' + opts.join(', '); }
                                                                              msg += '. Link: ' + url;
                                                                                    btn.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
                                                                                        }
                                                                                            build();
                                                                                                var target = form.addEventListener ? form : document;
                                                                                                    target.addEventListener('change', function (e) {
                                                                                                          if (e.target && e.target.name && e.target.name.indexOf('options[') === 0) { build(); }
                                                                                                              });
                                                                                                                });
})();
